module.exports = __webpack_public_path__ + "img/logo-um-pef.2ec612ab.png";